<template>
  <div class="home" :style="{width: homeWidth}">
    <template v-if="homeCheck">
      <div class="load">
        <img src="@/assets/loading.png" alt="loading">
      </div>
    </template>
    <template v-else>
      <div class="fd-r jc-c" style="margin-bottom: 40px;">
        <img style="width: 80%;height: auto;margin-top: 48px;" src="@/assets/404.png" alt="404">
      </div>
      <div class="fd-r jc-c" style="font-size: 24px;font-weight: bold;line-height: 40px;color: #1482f0;margin-bottom: 20px;">404 Error!</div>
      <div class="fd-r jc-c" style="font-size: 16px;line-height: 24px;color: #222;font-weight: bold;margin-bottom: 10px;">Page not found!</div>
      <div class="fd-r jc-c" style="font-size: 12px;line-height: 22px;color: grey;text-align: center;padding: 0 40px;margin-bottom: 30px;">
        Sorry, the page you are looking for does not exist. Try checking the URL for errors and pressing the refresh
        button on your browser or try to find something else in our app.
      </div>
    </template>
  </div>
</template>

<style scoped>
  .home {
    margin: auto;
    max-width: 500px;
    position: relative;
  }
  .load {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }
  .load img {
    width: 80px;
    animation: spin 1s linear infinite;
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>

<script>
  export default {
    name: 'homeView',
    data() {
      return {
        homeWidth: "0", // 屏幕宽度
        homeCheck: true // 参数验证
      }
    },
    mounted() {
      this.homeWidth = window.innerWidth + 'px'

      let config = this.getHashParams().config;

      if (config && config.length === 12 && parseInt(config) > 112402763750) {
        if (this.isIos()) {
          this.$router.push({ path: '/ios', query: { config: config } })
        } else {
          this.$router.push({ path: '/android', query: { config: config } })
        }
      } else {
        this.homeCheck = false;
      }
    },
    methods: {
      // 判断苹果设备
      isIos() {
        return /iPhone|iPad|iPod/i.test(navigator.userAgent);
      },
      // 获取配置参数
      getHashParams() {
        const params = {};
        const urlParams = new URLSearchParams(window.location.href.split('#/?')[1]);
        for (let key of urlParams.keys()) {
          params[key] = urlParams.get(key);
        }
        return params;
      }
    }
  }
</script>
